import * as React from 'react';
import Modal from '@mui/material/Modal';
import axios from 'axios';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useState } from 'react';
import baseUrlApi from '../../lib/baseUrlApi';
import {ApiRequest} from "../../Consts/ApiRequest";
import { modalProps } from '../../Consts/constants';
import {useNavigate} from "react-router-dom";
import { useCookies } from 'react-cookie';
import Utility from "../../Consts/Utility";

type GatewayInputs = {
    prdKind: number,
    gatewayRecnoOld: number,
    gatewayRecno: number,
    gatewayID: string,
    controlID: string,
    siteRecno: number,
    noise: {
        sensorRecnoOld: number,
        sensorRecno: number,
        sensorID: string
    },
    env: {
        sensorRecnoOld: number,
        sensorRecno: number,
        sensorID: string
    },
    sui: {
        sensorRecnoOld: number,
        sensorRecno: number,
        sensorID: string
    },
    contactEnd: string
};
interface GatewayDelsetProps {
    controlId?: string;
    gatewayRecno?: number;
    closeModal: Function;
    setState: Function;
    contactEnd: string;
    suiSensorId?: string;
    suiSensorRecno?: number;
    envSensorId?: string;
    envSensorRecno?: number;
    noiseSensorId?: string;
    noiseSensorRecno?: number;
    siteId?: string;
    siteRecno?: string;
};
export default function GatewayAdminModalDelete(props: GatewayDelsetProps) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const controlId = props.controlId;
    const gatewayRecno = props.gatewayRecno;
    const closeModal = props.closeModal;
    const contactEnd = props.contactEnd;
    const { register, handleSubmit, formState: { errors } } = useForm<GatewayInputs>();
    const [error, setError] = useState<[]>([]);
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const navigate = useNavigate();

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    const onSubmit: SubmitHandler<GatewayInputs> = async (data) => {
        const token = cookies.access_token || "";
        let params = {
            "prcKind": 2,
            "gatewayRecnoOld": props.gatewayRecno,
            "gatewayRecno": gatewayRecno,
            "gatewayID": controlId,
            "siteRecno": props.siteRecno,
            "contactEnd": Utility.ReformatDate(Utility.formatDateStr(contactEnd)),
            "noise": {
                // "sensorRecnoOld": ,
                "sensorRecno": props.noiseSensorRecno || "",
                "sensorID": props.noiseSensorId || ""
            },
            "env": {
                // "sensorRecnoOld": ,
                "sensorRecno": props.envSensorRecno || "",
                "sensorID": props.envSensorId || ""
            },
            "sui": {
                // "sensorRecnoOld": ,
                "sensorRecno": props.suiSensorRecno || "",
                "sensorID": props.suiSensorId || ""
            },
        };
        await ApiRequest.registGatewaySensor(params, token, (response: any) => {
            setError(response.data.messsages);
            console.log(response.data);
            if (response.data.result === 0) {
                handleClose();
                closeModal();
                props.setState(" ");
            }
        }, (error: any) => {
            errorCallback(error);
        });
    }

    return (
        <div>
            <button onClick={handleOpen} className="btn btn-red-line">
                <i className="icon-delete-r">
                </i>削除</button>

                <Modal {...modalProps} open={open}>
                <div className="modal-wrapper" style={{ display: "flex" }} id="modal-message">
                    <div className="modal">
                        <div className="modal-header">
                            <div className="modal-title">
                                削除確認
                            </div>
                            <a onClick={handleClose} className="modal-close"></a>
                        </div>
                        <div className="modal-body">
                            <div className="edit-box">
                                {
                                    error && error.length > 0 ?
                                        <ul className="error-box">
                                            {error.map((err, index) => <li key={index}>{err}</li>)}
                                        </ul>
                                        : null
                                }

                                本当に削除してもよろしいですか？
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="model-action-sub">
                            </div>
                            <div className="model-action-main">
                                <button onClick={handleClose} className="btn btn-blue-line">
                                    キャンセル
                                </button>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <button className="btn btn-red-line">
                                        <i className="icon-delete-r"></i>確定
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
